export const CONFLUENCE_ACCESS_LINK = 'https://welltech.atlassian.net/wiki/x/nBMkLgE';
export const SLACK_CHANNEL_LINK = 'https://app.slack.com/client/T027KN150CW/C067QK3ND32';
